/**
 * @generated SignedSource<<2c79dca1546f24d6c995542adb080347>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BudgetSideEnum = "COST" | "REVENUE" | "%future added value";
export type BudgetUpsertInputObject = {
  basis?: string | null | undefined;
  entries: ReadonlyArray<BudgetEntryInputObject>;
  id?: string | null | undefined;
  name: string;
  perspectiveId?: string | null | undefined;
  side: BudgetSideEnum;
  year: number;
};
export type BudgetEntryInputObject = {
  amountCents: number;
  period: string;
  rowKey: string;
};
export type useBudgetEditor_UpsertMutation$variables = {
  input: BudgetUpsertInputObject;
};
export type useBudgetEditor_UpsertMutation$data = {
  readonly budgetUpsert: {
    readonly budget: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type useBudgetEditor_UpsertMutation = {
  response: useBudgetEditor_UpsertMutation$data;
  variables: useBudgetEditor_UpsertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Budget",
  "kind": "LinkedField",
  "name": "budget",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useBudgetEditor_UpsertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BudgetUpsertMutationPayload",
        "kind": "LinkedField",
        "name": "budgetUpsert",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBudgetEditor_UpsertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BudgetUpsertMutationPayload",
        "kind": "LinkedField",
        "name": "budgetUpsert",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1fd44921e9fd47c2086c4df7768b8c2c",
    "id": null,
    "metadata": {},
    "name": "useBudgetEditor_UpsertMutation",
    "operationKind": "mutation",
    "text": "mutation useBudgetEditor_UpsertMutation(\n  $input: BudgetUpsertInputObject!\n) {\n  budgetUpsert(input: $input) {\n    budget {\n      id\n      name\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "efa0b902bd3b6081128dfdad2a547581";

export default node;
